import { ReactComponent as Eye } from "asset/svg/eye.svg";
import { ReactComponent as EyeOff } from "asset/svg/eye-off.svg";
import { ReactComponent as Key } from "asset/svg/key.svg";
import { ReactComponent as Email } from "asset/svg/email.svg";
import { ReactComponent as Logout } from "asset/svg/logout.svg";
import { ReactComponent as ChevronDown } from "asset/svg/chevron-down.svg";
import { ReactComponent as ChevronRight } from "asset/svg/chevron-right.svg";
import { ReactComponent as ArrowLeft } from "asset/svg/arrow-left.svg";
import { ReactComponent as Layer } from "asset/svg/layer.svg";
import { ReactComponent as Edit } from "asset/svg/edit.svg";
import { ReactComponent as Timer } from "asset/svg/timer.svg";
import { ReactComponent as Clock } from "asset/svg/clock.svg";
import { ReactComponent as Delete } from "asset/svg/delete.svg";
import { ReactComponent as AlignJustify } from "asset/svg/align-justify.svg";
import { ReactComponent as Apps } from "asset/svg/apps.svg";
import { ReactComponent as Dashboard3 } from "asset/svg/dashboard-3.svg";
import { ReactComponent as DoubleArrowUp } from "asset/svg/double-arrow-up.svg";
import { ReactComponent as Support } from "asset/svg/support.svg";
import { ReactComponent as UserGroup } from "asset/svg/user-group.svg";
import { ReactComponent as User } from "asset/svg/user.svg";
import { ReactComponent as Clear } from "asset/svg/clear.svg";
import { ReactComponent as ArrowDownRight } from "asset/svg/arrow-down-right.svg";
import { ReactComponent as ArrowUpRight } from "asset/svg/arrow-up-right.svg";
import { ReactComponent as DateRange } from "asset/svg/date-range.svg";
import { ReactComponent as Ambulance } from "asset/svg/ambulance.svg";
import { ReactComponent as Search } from "asset/svg/search.svg";
import { ReactComponent as GripVertical } from "asset/svg/grip-vertical.svg";

type IconSVGProps = React.SVGProps<SVGSVGElement> & {
  title?: string | undefined;
  ownerState?: any;
};

export type IconType = React.FunctionComponent<IconSVGProps>;

const defaultProps: IconSVGProps = {
  width: 20,
  height: 20,
};

// Helper function to filter out ownerState prop
const filterProps = ({ ownerState, ...rest }: IconSVGProps): Omit<IconSVGProps, 'ownerState'> => rest;

export const EyeIcon: IconType = (props) => <Eye {...defaultProps} {...filterProps(props)} />;
export const EyeOffIcon: IconType = (props) => <EyeOff {...defaultProps} {...filterProps(props)} />;
export const KeyIcon: IconType = (props) => <Key {...defaultProps} {...filterProps(props)} />;
export const EmailIcon: IconType = (props) => <Email {...defaultProps} {...filterProps(props)} />;
export const LogoutIcon: IconType = (props) => <Logout {...defaultProps} {...filterProps(props)} />;
export const ChevronDownIcon: IconType = (props) => <ChevronDown {...defaultProps} {...filterProps(props)} />;
export const ChevronRightIcon: IconType = (props) => <ChevronRight {...defaultProps} {...filterProps(props)} />;
export const ArrowLeftIcon: IconType = (props) => <ArrowLeft {...defaultProps} {...filterProps(props)} />;
export const LayerIcon: IconType = (props) => <Layer {...defaultProps} {...filterProps(props)} />;
export const EditIcon: IconType = (props) => <Edit {...defaultProps} {...filterProps(props)} />;
export const TimerIcon: IconType = (props) => <Timer {...defaultProps} {...filterProps(props)} />;
export const ClockIcon: IconType = (props) => <Clock {...defaultProps} {...filterProps(props)} />;
export const DeleteIcon: IconType = (props) => <Delete {...defaultProps} {...filterProps(props)} />;
export const AlignJustifyIcon: IconType = (props) => <AlignJustify {...defaultProps} {...filterProps(props)} />;
export const AppsIcon: IconType = (props) => <Apps {...defaultProps} {...filterProps(props)} />;
export const Dashboard3Icon: IconType = (props) => <Dashboard3 {...defaultProps} {...filterProps(props)} />;
export const DoubleArrowUpIcon: IconType = (props) => <DoubleArrowUp {...defaultProps} {...filterProps(props)} />;
export const SupportIcon: IconType = (props) => <Support {...defaultProps} {...filterProps(props)} />;
export const UserGroupIcon: IconType = (props) => <UserGroup {...defaultProps} {...filterProps(props)} />;
export const UserIcon: IconType = (props) => <User {...defaultProps} {...filterProps(props)} />;
export const ClearIcon: IconType = (props) => <Clear {...defaultProps} {...filterProps(props)} />;
export const ArrowDownRightIcon: IconType = (props) => <ArrowDownRight {...defaultProps} {...filterProps(props)} />;
export const ArrowUpRightIcon: IconType = (props) => <ArrowUpRight {...defaultProps} {...filterProps(props)} />;
export const DateRangeIcon: IconType = (props) => <DateRange {...defaultProps} {...filterProps(props)} />;
export const AmbulanceIcon: IconType = (props) => <Ambulance {...defaultProps} {...filterProps(props)} />;
export const SearchIcon: IconType = (props) => <Search {...defaultProps} {...filterProps(props)} />;
export const GripVerticalIcon: IconType = (props) => <GripVertical {...defaultProps} {...filterProps(props)} />;
